/* ════════════════════════════════════════════════════════════════════════
   STICKY ADD TO CART — loader + reveal fix   (Claude, 2026-08-13)

   THE BUG
   The sticky bar was rendered on every product page and never shown.
   sections/sticky-add-to-cart.liquid styles it as:

     sticky-add-to-cart      { visibility:hidden; opacity:0; translateY(100%) }
     sticky-add-to-cart.show { visibility:visible; opacity:1; translateY(0) }

   Nothing ever added `.show`. The original script defined only the
   <sticky-add-to-cart-options> variant select — zero references to "show",
   scroll, IntersectionObserver or observe — and <sticky-add-to-cart> itself
   was never registered as a custom element. The bar was fully built, fully
   styled, and permanently invisible on every device.

   WHY IT COST MONEY
   Desktop barely noticed: the buy box sits ~518px down, inside the first
   screen. Mobile stacks it below the gallery, title and benefit bullets —
   about a screen and a half down — with no safety net.
   30-day cart-add rate: desktop 16.0%, mobile 6.2%. Mobile is ~70% of
   store traffic.

   STRUCTURE
   The original file is untouched at assets/sticky-add-to-cart-core.js — it
   was copied server-side, byte for byte, rather than retyped. This file
   loads it and adds the missing reveal behaviour. To revert, copy
   sticky-add-to-cart-core.js back over this file.
   ═══════════════════════════════════════════════════════════════════════ */

/* 1 · Load the original variant-selector logic, unchanged.
      Resolved relative to this script so it works on any theme id. */
(function () {
  var me = document.currentScript && document.currentScript.src;
  if (!me) return;
  var core = me.replace(/sticky-add-to-cart\.js/, 'sticky-add-to-cart-core.js');
  if (core === me) return;
  var s = document.createElement('script');
  s.src = core;
  s.defer = true;
  document.head.appendChild(s);
})();

/* 2 · The missing piece: actually reveal the bar.
      Shows once the shopper has scrolled about a screen AND the real Add to
      cart is off-screen. Hides again whenever the real button is visible, so
      there are never two competing buttons. */
(function () {
  function init() {
    var bar = document.querySelector('sticky-add-to-cart');
    if (!bar) return;

    // The main product form's button — never the one inside the bar itself.
    var main = document.querySelector('section[id^="MainProduct-"]') || document;
    var atc = main.querySelector('.product-form__submit, button[name="add"]');
    if (!atc || bar.contains(atc)) return;

    var atcVisible = false;
    var SCROLLED_ENOUGH = 600; // ~one phone screen; the one number to tune

    function update() {
      bar.classList.toggle('show', !atcVisible && window.scrollY > SCROLLED_ENOUGH);
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        atcVisible = entries[0].isIntersecting;
        update();
      }, { rootMargin: '0px 0px -80px 0px' }).observe(atc);
    }

    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { update(); ticking = false; });
    }, { passive: true });

    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
